module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/H1-a046b456bbb738fb87bfb7343249fe91.svg";